import type { WidgetPublicResolveBySlugResponse } from "@shared/contracts/widgets/public/resolveBySlug";
import type { WidgetLocale } from "@shared/widgets/localeResolver";
import { urls } from "@shared/urls";

export const WIDGET_API_BASE = import.meta.env.VITE_WIDGET_API_BASE ?? urls.auth;

export const buildWidgetUrl = (slug: string, locale: WidgetLocale): string =>
  `${WIDGET_API_BASE}/api/widgets/${encodeURIComponent(slug)}?lang=${locale}`;

export type FetchResult =
  | { kind: "ok"; payload: WidgetPublicResolveBySlugResponse }
  | { kind: "not_found" }
  | { kind: "error"; reason: string };

export const fetchWidget = async (
  slug: string,
  locale: WidgetLocale,
  fetchImpl: typeof fetch = fetch,
): Promise<FetchResult> => {
  try {
    const response = await fetchImpl(buildWidgetUrl(slug, locale), {
      method: "GET",
      cache: "default",
      credentials: "omit",
      mode: "cors",
    });
    if (response.status === 404) return { kind: "not_found" };
    if (!response.ok) return { kind: "error", reason: `http_${response.status}` };
    const payload = (await response.json()) as WidgetPublicResolveBySlugResponse;
    return { kind: "ok", payload };
  } catch (error) {
    return { kind: "error", reason: error instanceof Error ? error.message : "network_error" };
  }
};
